export default __webpack_public_path__ + "static/media/CollectionEmpty.e855fbf5.svg";